export default __webpack_public_path__ + "img/homepage.product.02.asset.9dfd3fef.jpg";